<template>
  <Layout title="Book a Ride" description="Create your booking with full details.">
    <div class="container py-5" style="max-width: 800px;">
      <div class="card shadow">
        <div class="card-header bg-dark text-light d-flex justify-content-between align-items-center flex-wrap gap-2">
          <div>
            <h3 class="mb-0">Book a Ride</h3>
            <small class="text-muted">Fill in the details below to book your ride</small>
          </div>

          <!-- <button
            type="button"
            class="btn btn-success d-flex align-items-center gap-2 fw-semibold"
            @click="$router.push('/Tutorial')"
          >
            Tutorial
          </button> -->
        </div>


        <div class="card-body">

          <form @submit.prevent="handleSubmit" class="row g-4">
            <!-- Start Date -->
            <div class="col-md-6">
              <label for="startDate" class="form-label">Start Date *</label>
              <input
                type="date"
                id="startDate"
                v-model="startDate"
                class="form-control"
                required
              />
            </div>

            <!-- Start Time -->
            <div class="col-md-6">
              <label for="startTime" class="form-label">Start Time *</label>
              <br/>
               <div class="w-100">
                <VueTimepicker
                  v-model="formData.startTime"
                  format="HH:mm"
                  :hour-range="Array.from({ length: 24 }, (_, i) => i)"
                  :minute-range="Array.from({ length: 60 }, (_, i) => i)"
                  manual-input
                  class="vue__time-picker w-100"
                />

              </div>

            </div>

            <!-- Vessel Name -->
            <div class="col-md-6">
              <label for="vesselName" class="form-label">Vessel Name</label>
              <input
                type="text"
                id="vesselName"
                v-model="formData.vesselName"
                class="form-control"
                placeholder="Enter vessel name if applicable"
              />
            </div>

            <!-- Counter Dropdown -->
            <div class="col-md-6">
              <label for="counterNumber" class="form-label">Counter *</label>
              <select
                id="counterNumber"
                v-model="formData.counterNumber"
                class="form-select"
                required
              >
                <option disabled value="">Select Counter</option>
                <option value= "NA">N/A</option>
                <option v-for="n in 16" :key="n" :value="'Counter ' + n">
                  Counter {{ n }}
                </option>
              </select>
            </div>
            <!-- Client Dropdown -->
            <div class="col-md-6">
              <label for="clientSelect" class="form-label">Agent*</label>
              <select
                id="clientSelect"
                v-model="formData.clientId"
                class="form-select"
                required
              >
                <option disabled value="">Select Client</option>
            
                <option
                  v-for="client in clients"
                  :key="client.id"
                  :value="client.id"
                >
                  {{ client["name"] }}
                </option>
              </select>
            </div>
            <div class="col-md-6">
              <label class="form-label">Booking Type *</label>
              <select
                v-model="formData.bookingType"
                class="form-select"
                required
              >
                <option disabled value="">Select Booking Type</option>
                <option value="arrival">Arrival</option>
                <option value="departure">Departure</option>
                <option value="transfer">Transfer</option>
                <option value="disposal">Disposal</option>
                <option value="parcel">Parcel</option>
              </select>
            </div>
            <!-- Crew Name (Dynamic Array) -->
            <!-- <div class="col-md-6">
              <label for="vesselName" class="form-label">Crew Rank and Name</label>
              <input
                type="text"
                id="crewName"
                v-model="formData.crewName"
                class="form-control"
                placeholder="Enter Crew Name"
              />
            </div>
            <div class="col-md-12">
              <label class="form-label">
                Crew Contacts <small>(Include country code)</small> *
              </label>

              <div
                v-for="(contact, index) in formData.pocContact"
                :key="index"
                class="d-flex gap-2 mb-2 align-items-center"
              >
                <vue-tel-input
                  ref="pocTelInputRefs"
                  :ref_for="true"
                  v-model="formData.pocContact[index]"
                  mode="international"
                  placeholder="Enter contact number"
                  required
                  style="flex:1;"
                />



                <button
                  type="button"
                  class="btn btn-danger"
                  @click="removeContact(index)"
                  v-if="formData.pocContact.length > 1"
                >
                  Remove
                </button>
              </div>

              <button
                type="button"
                class="btn btn-outline-primary btn-sm"
                @click="addContact"
              >
                + Add Contact
              </button>
            </div> -->

            
            <!-- Number of People -->
            <div class="col-md-6">
              <label for="pax" class="form-label">Number of People *</label>
              <input
                type="number"
                id="pax"
                v-model="formData.pax"
                class="form-control"
                min="1"
                placeholder="1"
                required
              />
            </div>

            <!-- Start Location -->
            <div class="col-6">
              <label for="startLocation" class="form-label">Start Location *</label>
              <input
                type="text"
                id="startLocation"
                v-model="formData.startLocation"
                class="form-control"
                placeholder="Enter pickup location"
                required
              />
            </div>
            <!-- End Location -->
            <div class="col-6">
              <label for="endLocation" class="form-label">End Location *</label>
              <input
                type="text"
                id="endLocation"
                v-model="formData.endLocation"
                class="form-control"
                placeholder="Enter drop-off location"
                required
              />
            </div>

            <!-- Trips (Dynamic Array) -->
            <div class="col-12">
              <label class="form-label">Additional (Optional)</label>
              <div
                v-for="(trip, index) in formData.trips"
                :key="index"
                class="d-flex gap-2 mb-2"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="formData.trips[index]"
                  placeholder="e.g. Marina Bay → Changi Airport"
                />
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="removeTrip(index)"
                >
                  Remove
                </button>
              </div>
              <button
                type="button"
                class="btn btn-outline-primary btn-sm"
                @click="addTrip"
              >
                + Add Trip
              </button>
            </div>


            

            <!-- Flight Numbers (Dynamic Array) -->
            <div class="col-12">
              <label class="form-label">Flight Numbers</label>

              <div
                v-for="(flight, index) in formData.flightNumbers"
                :key="index"
                class="border rounded p-3 mb-3"
              >
                <div class="row g-2">

                  <!-- Flight Number -->
                  <div class="col-12">
                    <input
                      type="text"
                      class="form-control"
                      v-model="flight.number"
                      placeholder="e.g. SQ316"
                    />
                  </div>

                  <!-- Arrival -->
                  <!-- <div class="col-6">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="flight.isArrival"
                        :id="`arrival-${index}`"
                        @change="handleArrivalChange(index)"
                      />
                      <label class="form-check-label" :for="`arrival-${index}`">
                        Arrival
                      </label>
                    </div>
                  </div> -->

                  <!-- Departure -->
                  <!-- <div class="col-6">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="flight.isDeparture"
                        :id="`departure-${index}`"
                        @change="handleDepartureChange(index)"
                      />
                      <label class="form-check-label" :for="`departure-${index}`">
                        Departure
                      </label>
                    </div>
                  </div> -->

                  <!-- Remove -->
                  <div class="col-12">
                    <button
                      type="button"
                      class="btn btn-danger w-100"
                      @click="removeFlight(index)"
                    >
                      Remove
                    </button>
                  </div>

                </div>
              </div>
              <button
                type="button"
                class="btn btn-outline-primary btn-sm"
                @click="addFlight"
              >
                + Add Flight
              </button>
            </div>


            <!-- Crew Members Dynamic -->
            <div class="col-12">
              <label class="form-label">Crew Details *</label>

              <div
                v-for="(crew, index) in formData.crewMembers"
                :key="index"
                class="border rounded p-3 mb-3"
              >
                <div class="row g-2">

                  <div class="col-md-6">
                    <input
                      type="text"
                      class="form-control"
                      v-model="crew.rank"
                      placeholder="Crew Rank"
                      required
                    />
                  </div>


                  <!-- Crew Name -->
                  <div class="col-md-6">
                    <input
                      type="text"
                      class="form-control"
                      v-model="crew.name"
                      placeholder="Crew Name"
                      required
                    />
                  </div>

                  <!-- Crew Contact -->
                  <div class="col-md-6">
                    <vue-tel-input
                      ref="crewTelInputRefs"
                      :ref_for="true"
                      v-model="formData.crewMembers[index].contact"
                      mode="international"
                      placeholder="Contact number"
                      required
                    />


                  </div>

                  <!-- Remove -->
                  <div class="col-md-4 d-flex align-items-center">
                    <button
                      type="button"
                      class="btn btn-danger w-100"
                      @click="removeCrew(index)"
                      v-if="formData.crewMembers.length > 1"
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-outline-primary btn-sm"
                @click="addCrew"
              >
                + Add Crew
              </button>
            </div>


            

            <!-- Number of Luggage -->
            <!-- <div class="col-md-6">
              <label for="luggage" class="form-label">Number of Luggage</label>
              <input
                type="number"
                id="luggage"
                v-model="formData.luggage"
                class="form-control"
                min="0"
                placeholder="0"
              />
            </div> -->

            <!-- File Upload (Dynamic like Flight) -->
            <div class="col-12">
              <label class="form-label">Upload Documents (Optional)</label>
              <div
                v-for="(fileObj, index) in uploadedFiles"
                :key="index"
                class="d-flex gap-2 mb-2"
              >
                <input
                  type="file"
                  class="form-control"
                  @change="onFileChange($event, index)"
                />
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="removeFile(index)"
                >
                  Remove
                </button>
              </div>
              <button
                type="button"
                class="btn btn-outline-primary btn-sm"
                @click="addFile"
              >
                + Add File
              </button>
              <ul class="mt-2 small" v-if="uploadedFiles.length > 0">
                <li v-for="(fileObj, index) in uploadedFiles" :key="'file-' + index">
                  {{ fileObj.file ? fileObj.file.name : 'No file selected' }}
                </li>
              </ul>
            </div>

            <!-- Remarks -->
            <div class="col-12">
              <label for="remarks" class="form-label">Remarks</label>
              <textarea
                id="remarks"
                v-model="formData.remarks"
                class="form-control"
                rows="3"
                placeholder="Any special notes"
              ></textarea>
            </div>

            <!-- Submit -->
            <div class="col-12">
              <button
                type="submit"
                class="btn btn-warning w-100 fw-bold"
                :disabled="isSubmitting"
              >
                <span v-if="!isSubmitting">Submit Booking</span>
                <span
                  v-else
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout.vue'
import { useToast } from 'vue-toastification'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import router from '@/router'
import axios from 'axios'
import { VueTelInput } from 'vue3-tel-input'
import 'vue3-tel-input/dist/vue3-tel-input.css'
import VueTimepicker from 'vue3-timepicker'
import 'vue3-timepicker/dist/VueTimepicker.css'

export default {
  name: 'BookingForm',
  components: { Layout, VueTelInput,VueTimepicker  },
  data() {
    return {
      startDate: '',
      isSubmitting: false,
      isAdmin: false, // 👈 new
      clients: [], // 👈 new
      uploadedFiles: [{ file: null }],
      formData: {
        clientId: "",
        startTime: '',
        startLocation: '',
        endLocation: '',
        vesselName: '',
        counterNumber: '',
        bookingType:"",
        flightNumbers: [ { number: '', isArrival: false }],
        pax: '',
        luggage: '',
        remarks: '',
        pocContact: [''],
        trips: [''],
        crewName:"",
        crewMembers: [
          { rank: '',name: '', contact: '' }
        ]
      },
    }
  },
  setup() {
    const toast = useToast()
    return { toast }
  },
  async mounted() {
    this.userID = this.$store.getters.getUserId
    console.log(this.$store.state.systemAccess.admin)
    await this.checkAuthState()
    await this.checkPageAccess(["admin"])
    await this.loadClients()
  },
  methods: {
    
    async loadClients() {
      try {
        const headers = await this.getAuthHeader();
        const res = await axios.get(`${this.$apiURL}/clients`, { headers });
        this.clients = res.data.clients || [];
        console.log(this.clients)
      } catch (err) {
        console.error("❌ Failed to load clients:", err.message);
        this.toast.error("Failed to load clients");
      }
    },
    addCrew() {
      this.formData.crewMembers.push({ rank: '',name: '', contact: '' })
    },

    removeCrew(index) {
      this.formData.crewMembers.splice(index, 1)
    },
    addTrip() {
      this.formData.trips.push('')
    },
    removeTrip(index) {
      this.formData.trips.splice(index, 1)
    },
    // Flight logic
    addFlight() {
      this.formData.flightNumbers.push({ number: '', isArrival: false, isDeparture: false })
    },
    removeFlight(index) {
      this.formData.flightNumbers.splice(index, 1)
    },
    handleArrivalChange(index) {
      if (this.formData.flightNumbers[index].isArrival) {
        this.formData.flightNumbers[index].isDeparture = false
      }
    },

    handleDepartureChange(index) {
      if (this.formData.flightNumbers[index].isDeparture) {
        this.formData.flightNumbers[index].isArrival = false
      }
    },

    // File upload logic
    addFile() {
      this.uploadedFiles.push({ file: null })
    },
    removeFile(index) {
      this.uploadedFiles.splice(index, 1)
    },
    addContact() {
      if (!Array.isArray(this.formData.pocContact)) {
        this.formData.pocContact = []
      }
      this.formData.pocContact.push('')
    },
    removeContact(index) {
      this.formData.pocContact.splice(index, 1)
    },
    onFileChange(e, index) {
      const file = e.target.files[0]
      if (file) this.uploadedFiles[index].file = file
    },

    async handleSubmit() {
      try {
        this.isSubmitting = true
        const headers = await this.getAuthHeader()

        // ✅ extract POC contact numbers
        // let pocNumbers = []

        // if (this.$refs.pocTelInputRefs && Array.isArray(this.$refs.pocTelInputRefs)) {
        //   pocNumbers = this.$refs.pocTelInputRefs
        //     .map(ref => ref?.modelValue || ref?.number || ref?.phone)
        //     .filter(v => !!v && v.trim() !== '')
        // }

        // if (!pocNumbers.length && Array.isArray(this.formData.pocContact)) {
        //   pocNumbers = this.formData.pocContact.filter(v => !!v && v.trim() !== '')
        // }
        let crewMembers = []

        if (this.$refs.crewTelInputRefs) {
          let refs = this.$refs.crewTelInputRefs

          if (!Array.isArray(refs)) {
            refs = [refs]
          }

          crewMembers = refs
            .map((ref, index) => {
              const raw =
                ref?.modelValue ||
                ref?.number ||
                ref?.phone ||
                this.formData.crewMembers[index]?.contact ||
                ''

              return {
                rank: (this.formData.crewMembers[index]?.rank || '').trim(),
                name: (this.formData.crewMembers[index]?.name || '').trim(),
                contact: raw?.number || raw || ''
              }
            })
            .filter(c => c.name)
        }



        console.log(this.formData.crewMembers)

        // ✅ build ISO start time
        const startTimeISO = new Date(
          `${this.startDate}T${this.formData.startTime}`
        ).toISOString()

        // ✅ payload (flightNumbers AS-IS)
        const payload = {
          clientId: this.formData.clientId,
          pax: Number(this.formData.pax),
          startLocation: this.formData.startLocation,
          endLocation: this.formData.endLocation,
          startTime: startTimeISO,
          bookingType: this.formData.bookingType,
          // pocContact: pocNumbers,
          vesselName: this.formData.vesselName || "",
          crewName: this.formData.crewName || "",
          counterNumber: this.formData.counterNumber,
          flightNumbers: this.formData.flightNumbers.filter(
            f => (f.number || "").trim() !== ""
          ),
          remarks: this.formData.remarks || "",
          trips: this.formData.trips.filter(t => t.trim() !== ""),
          crewMembers: crewMembers
        }
        const formDataPayload = new FormData()

        // append JSON payload
        formDataPayload.append("data", JSON.stringify(payload))

        // append files
        this.uploadedFiles.forEach((f, ) => {
          if (f.file) {
            formDataPayload.append("files", f.file)
          }
        })

        const response = await axios.post(
          `${this.$apiURL}/api/bookings`,
          formDataPayload,
          { headers }
        )

        if (response.data?.ok) {
          this.toast.success("✅ Booking created successfully!")
          window.location.reload()
        } else {
          this.toast.error(response.data?.error || "Failed to create booking")
        }

      } catch (err) {
        console.error("❌ Booking API error:", err)
        this.toast.error(err.response?.data?.error || "Error creating booking")
      } finally {
        this.isSubmitting = false
        this.uploadedFiles = [{ file: null }]
        this.resetForm()
      }
    },

    resetForm() {
      this.startDate = ''
      this.uploadedFiles = [{ file: null }]
      this.formData = {
        startTime: '',
        startLocation: '',
        endLocation: '',
        vesselName: '',
        counterNumber: '',
        flightNumbers: [''],
        pax: '',
        luggage: '',
        remarks: '',
        // pocContact: [''],
        crewMembers: [{rank: '',name: '', contact: '' }],
      }
    },
    async getAuthHeader() {
      const user = getAuth().currentUser
      if (!user) throw new Error('Not logged in')
      const token = await user.getIdToken()
      return { Authorization: token }
    },
    checkPageAccess(allowedRoles = []) {
      const access = this.$store.state.systemAccess || {}

      const hasAccess = allowedRoles.some(role => access[role] === true)

      if (!hasAccess) {
        this.toast.error("Access denied.")

        if (access.admin === true) {
          router.push("/crm")
        } else if (access.client === true) {
          router.push("/JobManagementClient")
        } else if (access.driver === true) {
          router.push("/JobManagementDriver")
        } else {
          router.push("/")
        }
      }
    },

    async checkAuthState() {
      const auth = getAuth()
      return new Promise((resolve, reject) => {
        onAuthStateChanged(auth, async (user) => {
          if (user) {
            try {
              const idToken = await user.getIdToken()
              this.token = idToken

              // ✅ Check claims to see if admin
              const res = await axios.get(`${this.$apiURL}/api/systemAccess`, {
                headers: { Authorization: idToken }
              })
              const claims = res.data.claims || {}
              this.isAdmin = !!claims.admin

              resolve()
            } catch (error) {
              reject(error)
            }
          } else {
            router.push('/')
            reject(new Error('No user logged in'))
          }
        })
      })
    },
  },
}
</script>

<style scoped>
button.btn-outline-primary.btn-sm {
  margin-top: 0.3rem;
}

.vue-timepicker-wrapper {
  width: 100%;
}

/* make its internal input match Bootstrap form-control */
:deep(.vue__time-picker input) {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

:deep(.vue__time-picker input:focus) {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13,110,253,0.25);
}


</style>
